// extracted by mini-css-extract-plugin
export default {"layout":"Navigation_layout__S5-3h","open":"Navigation_open__NBbA2","brand":"Navigation_brand__Aw7iT","nav":"Navigation_nav__sthmV","content":"Navigation_content__iLggB"};